import { HostClientType } from '@microsoft/teams-js';

export { HostClientType };

const standaloneClients: HostClientType[] = [
  HostClientType.desktop,
  HostClientType.android,
  HostClientType.ios,
  HostClientType.ipados,
];

export const isSafeToCachePersonalData = (hostClientType?: HostClientType): boolean =>
  !!hostClientType && standaloneClients.includes(hostClientType);
